import React, { Component } from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';

import { quipUserShape } from '../../types';
import { convertToQid } from '../../utilities/stringHelper';

export default class DeclareReviewers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmail: undefined,
    };
  }

  getUserWithEmail = (email) => this.props.users.find((user) => user.email === email);

  getEmails = () => this.props.users.map((user) => ({
    value: user.email,
    label: `${user.surname}, ${user.firstname}(${user.email}) ${convertToQid(user.id, (user.institute?.country || user.userCountry))}`,
  }));

  render() {
    const { selectedEmail } = this.state;
    const { reviewers, onDeclareReviewer, onUndeclareReviewer } = this.props;
    return (
      <div>
        <Select
          options={this.getEmails()}
          onChange={(selection) => this.setState({ selectedEmail: selection.value })}
        />
        <Button
          sx={{ my: 2, mr: 1 }}
          variant="contained"
          color="primary"
          onClick={async () => {
            await onDeclareReviewer(this.getUserWithEmail(selectedEmail));
            this.setState({ selectedEmail: '' });
          }}
          disabled={
        !selectedEmail
        || (reviewers
          && !!reviewers.find((reviewer) => reviewer.email === selectedEmail))
        }
        >
          <FormattedMessage id="declareReviewers.addReviewerButton" />
        </Button>
        <Button
          sx={{ my: 2, mr: 1 }}
          variant="contained"
          color="secondary"
          onClick={async () => {
            await onUndeclareReviewer(this.getUserWithEmail(selectedEmail));
            this.setState({ selectedEmail: '' });
          }}
          disabled={
          !selectedEmail
          || (reviewers
            && !reviewers.find(
              (reviewer) => reviewer.email === selectedEmail,
            ))
          }
        >
          <FormattedMessage id="declareReviewers.removeReviewerButton" />
        </Button>
      </div>
    );
  }
}

DeclareReviewers.propTypes = {
  users: PropTypes.arrayOf(quipUserShape).isRequired,
  reviewers: PropTypes.arrayOf(quipUserShape).isRequired,
  onDeclareReviewer: PropTypes.func.isRequired,
  onUndeclareReviewer: PropTypes.func.isRequired,
};
